import request from '@/utils/request'

export function getIntelligenceMatch(data){
    return request({
        url: '/bus/automatch',
        method: 'POST',
        data
      })
}